import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHMG } from '../../HMGContext';

const ViewAsUser = ({  }) => {
  const navigate = useNavigate();
  const {viewAsUserOpen, handleViewAsUserClose , selectedUser} = useHMG()

  const handleExitView = () => {
    navigate('/');
    handleViewAsUserClose()
  };

  let userName = selectedUser

if (!viewAsUserOpen) {
  return
}

  return (
    <div 
      style={{
        backgroundColor: '#e91e63',
        color: 'white',
        padding: '5px 8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '12px',
        lineHeight: "18px",
        fontWeight: '600',
        position: 'fixed',
        top: "0px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '250px',
        borderRadius: "0px 0px 8px 8px"
      }}
      className="global_alert"
    >
      <span>Viewing as {userName || 'Unknown User'}</span>
      <button
        onClick={handleExitView}
        style={{
          backgroundColor: '#FADDE7',
          border: '1px solid #FADDE7',
          color: '#E02D69',
          padding: '2px 4px',
          borderRadius: '4px',
          fontSize: '10px',
          cursor: 'pointer',
          fontWeight: '500',
          lineHeight: "16px",
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#FADDE7';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#FADDE7';
        }}
      >
        Exit view
      </button>
    </div>
  );
};

export default ViewAsUser;